var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#2070B8",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 12.9998C32.0424 13.6753 30.9821 14.1919 29.86 14.5298C29.2577 13.8373 28.4573 13.3465 27.567 13.1237C26.6767 12.901 25.7395 12.957 24.8821 13.2843C24.0247 13.6115 23.2884 14.1942 22.773 14.9535C22.2575 15.7128 21.9877 16.6121 22 17.5298V18.5298C20.2426 18.5754 18.5013 18.1856 16.931 17.3952C15.3607 16.6049 14.0103 15.4384 13 13.9998C13 13.9998 9 22.9998 18 26.9998C15.9405 28.3978 13.4872 29.0987 11 28.9998C20 33.9998 31 28.9998 31 17.4998C30.9991 17.2213 30.9723 16.9434 30.92 16.6698C31.9406 15.6633 32.6608 14.3925 33 12.9998Z",
    stroke: "#2070B8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.bf4b3e050d848d5a6eb1bebd3b407de1.svg";
export { ForwardRef as ReactComponent };